import { render, staticRenderFns } from "./ProgramIndex.vue?vue&type=template&id=658d3dbe"
import script from "./ProgramIndex.vue?vue&type=script&lang=js"
export * from "./ProgramIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports